export const defaultFilterParams = {
    STANDING_LOAD_ORDERS: [{columnName: 'type', currentValue: 'LOAD_ORDER'}],
    STANDING_SALE_ORDERS: [{columnName: 'type', currentValue: 'SALE_ORDER'}]
};
